export const TOTAL_PLAYERS_DISPLAY = 2;
export const TOTAL_PLAYERS_TV = 4;
export const PRE_RECORDED_NAMES = new Set([
  "thenomadandy",
  "FollowAlwaysDisneyWorld",
  "WorldScape",
  "GeoffreyNease",
  "WDW247",
  "goodenjoymenttv",
]);
export const TOP_STREAMERS = new Set([
  "ResortTV1",
  "PagingMrMorrow",
  "WDWNT",
  "WDWNTTV",
  "TheTrackers",
  "DailyFastPass",
  "CrazyDisneyLady",
  "ParkPassTV",
]);
export const BLOCKED_VIDEO_IDS = new Set(["vDNXhFgJjRA"]);

export function getBackgroundByEST() {
  const nowUTC = new Date();
  const estOffset = -4;
  const utcHour = nowUTC.getUTCHours();
  const estHour = (utcHour + estOffset + 24) % 24;
  return estHour >= 5 && estHour < 20
    ? "/static/vip/day.jpg"
    : "/static/vip/night.jpg";
}
export function getVipSelectorBackground(isTv) {
  const nowUTC = new Date();
  const estOffset = -4;
  const utcHour = nowUTC.getUTCHours();
  const estHour = (utcHour + estOffset + 24) % 24;
  const isDaytime = estHour >= 5 && estHour < 20;

  if (isTv && isDaytime) return "/static/vip/vip-doors-tv.jpg";
  if (isTv && !isDaytime) return "/static/vip/vip-doors-tv-night.jpg";
  if (!isTv && isDaytime) return "/static/vip/vip-doors-display.jpg";
  return "/static/vip/vip-doors-display-night.jpg";
}

